import { render, staticRenderFns } from "./ShowcaseTemplateEdit.vue?vue&type=template&id=60ae8cb7&"
import script from "./ShowcaseTemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseTemplateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports